module.exports = __webpack_public_path__ + "static/iot-system-3-d0e7009b710bee1aff5d1bfade4dace9.png";